import React, { FC } from 'react';
import styled from 'styled-components';
import { ProductiveHeading07 } from 'components/styles';
import { ResourceSectionType } from 'data/documents';
import { Task } from 'data/tasks';
import { INSERT_RESOURCE_LIST_SECTION_COMMAND } from 'vendor/ckeditor/plugins/resource-list-section';
import { Highlight } from '../highlight';
import styles from './highlight-section.module.css';

interface Props {
  config: {
    tasks: Task[];
    title: string;
    type: ResourceSectionType;
  };
  cardComponent?: FC<any>;
}
const Title = styled.p`
  ${ProductiveHeading07};
  margin-bottom: var(--spacing-02);
`;

export const HighlightSection: FC<Props> = ({ config, cardComponent }) => {
  const { title, tasks, type } = config;

  return (
    <div className={styles.highlights}>
      <Title>{title}</Title>
      {cardComponent ? (
        React.createElement(cardComponent, { tasks, type })
      ) : (
        <Highlight
          commandName={INSERT_RESOURCE_LIST_SECTION_COMMAND}
          commandOptions={{
            type,
          }}
          tasks={tasks}
          type={type}
        />
      )}
    </div>
  );
};
